export const customerFieldsLabelMixin = {
  methods: {
    getFieldLabel(field) {
      const defaultFields = {
        status: 'Status',
        comment_status: 'Comentário',
        pipedrive_id: 'ID do pipedrive',
        status_reason: 'Motivo do status',
        name: 'Nome fantasia',
        co_name: 'Razão social',
        email: 'E-mail',
        phone: 'Telefone',
        document: 'Documento',
        company_id: 'ID Empresa',
        segment_id: 'ID Segmento',
        size_id: 'ID Tamanho',
        start: 'Data do 1º acordo comercial',
        address: 'Endereço',
        city: 'Cidade',
        state: 'Estado',
        zipcode: 'CEP',
        ca_synchronized: 'Sincronizado CA',
        block_manually: 'Bloqueado manualmente',
        retention: 'Retenção',
        deposit: 'Depósito',
        is_automated: 'ERP Automatizado',
        billing_new_app: 'Faturar em New Way Lite',
        is_invoice_automated: 'Faturamento automatizado',
        business_executive_id: 'ID Executivo de negócios',
        customer_success_consultant_id: 'ID Consultor de sucesso',
        company_name: 'Nome da empresa',
        company_document: 'CNPJ da empresa',
        company_phone: 'Telefone da empresa',
        company_email: 'E-mail da empresa',
        simple: 'Simples',
        municipal_reg: 'Inscrição Municipal',
        state_reg: 'Inscrição Estadual',
        omie_bank_id: 'ID do banco Omie',
        omie_synchronized: 'Sincronizado Omie',
        external_id: 'ID Externo',
        automatic_finish_date: 'Data de finalização automática',
      };

      return defaultFields[field] || field;
    },
  },
};
